export const TITLE_TAB_VIEWS = [
    "Horarios de atención",
    "Días no hábiles"
];